import React from "react";
import {
  FaUsers,
  FaLaptopCode,
  FaChartLine,
  FaHeart,
  FaSmile,
  FaLightbulb,
  FaGlobe,
} from "react-icons/fa";
import careerHero from "../../../images/life1.jpg";
import life2 from "../../../images/life2.jpg";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { useNavigate } from "react-router-dom";

const Career = () => {
  const navigate = useNavigate();
  const jobs = [
    {
      title: "Frontend Developer",
      location: "Remote",
      experience: "2+ years",
      description:
        "Build modern, responsive web applications using React, Tailwind, and cutting-edge UI practices.",
    },
    {
      title: "Backend Developer",
      location: "Bangalore",
      experience: "3+ years",
      description:
        "Design scalable APIs, optimize databases, and work with cloud infrastructure to support our AI-driven hiring platform.",
    },
    {
      title: "AI/ML Engineer",
      location: "Remote",
      experience: "2+ years",
      description:
        "Develop and deploy AI models that power our recruitment automation and bias-free candidate matching.",
    },
    {
      title: "Product Manager",
      location: "Hybrid (Bangalore)",
      experience: "4+ years",
      description:
        "Drive product vision, manage cross-functional teams, and deliver features that make hiring smarter and fairer.",
    },
    {
      title: "UI/UX Designer",
      location: "Remote",
      experience: "2+ years",
      description:
        "Design beautiful, user-friendly interfaces that enhance recruiter and candidate experience on our platform.",
    },
  ];

  const styles = {
    container: {
      fontFamily: "var(--font-family)",
      backgroundColor: "var(--background-color)",
      color: "var(--subheading-color)",
      marginTop: "30px",
    },
    section: {
      padding: "10px 20px",
      maxWidth: "1200px",
      margin: "0 auto",
      textAlign: "center",
    },
    hero: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "25px",
      marginBottom: "60px",
    },
    heroHeading: {
      fontSize: "var(--heading-size)",
      fontWeight: "700",
      color: "var(--heading-color)",
    },
    heroText: {
      fontSize: "20px",
      maxWidth: "800px",
      lineHeight: "1.6",
      margin:"auto",
      marginBottom:"5px"
    },
    heroImage: {
      maxWidth: "100%",
      height: "auto",
      borderRadius: "var(--border-radius)",
      boxShadow: "var(--shadow-medium)",
    },
    cardsContainer: {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "20px",
      marginTop: "40px",
    },
    card: {
      backgroundColor: "#fff",
      padding: "30px",
      borderRadius: "var(--border-radius)",
      boxShadow: "var(--shadow-medium)",
      width: "260px",
      transition: "transform 0.3s, box-shadow 0.3s",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    icon: {
      fontSize: "40px",
      color: "var(--primary-color)",
      marginBottom: "15px",
    },
    cardTitle: {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "10px",
      color: "var(--primary-color)",
    },
    cardText: {
      fontSize: "16px",
      textAlign: "center",
    },
    jobsSection: {
      marginTop: "80px",
      textAlign: "left",
    },
    jobCard: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "var(--border-radius)",
      boxShadow: "var(--shadow-light)",
      marginBottom: "20px",
      transition: "transform 0.3s ease",
    },
    jobTitle: {
      fontSize: "20px",
      fontWeight: "600",
      color: "var(--heading-color)",
      marginBottom: "8px",
    },
    jobDetails: {
      fontSize: "16px",
      color: "var(--subheading-color)",
      marginBottom: "10px",
    },
    jobDesc: {
      fontSize: "16px",
      color: "#555",
      marginBottom: "10px",
      lineHeight: "1.5",
    },
    applyBtn: {
      backgroundColor: "var(--primary-color)",
      color: "#fff",
      padding: "10px 20px",
      border: "none",
      borderRadius: "var(--border-radius)",
      cursor: "pointer",
      transition: "background 0.3s",
    },
    cultureSection: {
      marginTop: "100px",
      textAlign: "center",
    },
    cultureGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "30px",
      marginTop: "40px",
      marginBottom:"30px"
    },
    cultureCard: {
      backgroundColor: "#fff",
      borderRadius: "var(--border-radius)",
      boxShadow: "var(--shadow-medium)",
      padding: "20px",
      textAlign: "center",
    },
    cultureImage: {
      width: "100%",
      height: "200px",
      objectFit: "cover",
      borderRadius: "var(--border-radius)",
      marginBottom: "15px",
    },
    cultureTitle: {
      fontSize: "20px",
      fontWeight: "600",
      color: "var(--primary-color)",
      marginBottom: "10px",
    },
    cultureText: {
      fontSize: "16px",
      color: "var(--subheading-color)",
      lineHeight: "1.5",
    },
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = "translateY(-8px)";
    e.currentTarget.style.boxShadow = "var(--shadow-dark)";
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "var(--shadow-medium)";
  };

  return (
    <>
      <Navbar />
      <div style={styles.container}>
        <div style={styles.section}>
          <div style={styles.hero}>
            <h1 style={styles.heroHeading}>Careers at eBench.ai</h1>
            <p style={styles.heroText}>
              At eBench.ai, we’re not just building a hiring platform—we’re
              creating the future of work. Join a team of innovators, engineers,
              and problem-solvers dedicated to making recruitment smarter,
              faster, and bias-free. If you’re ready to make an impact, we want
              you on our journey.
            </p>
            {/* <img src={careerHero} alt="Career Hero" style={styles.heroImage} /> */}
          </div>
        </div>

        {/* Why Work With Us */}
        <div style={styles.section}>
          <h2 style={{ ...styles.heroHeading, fontSize: "32px" }}>
            Why Work With Us
          </h2>
          <div style={styles.cardsContainer}>
            <div
              style={styles.card}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <FaLaptopCode style={styles.icon} />
              <h3 style={styles.cardTitle}>Cutting-edge Tech</h3>
              <p style={styles.cardText}>
                Work with AI, ML, and scalable systems that transform
                industries.
              </p>
            </div>
            <div
              style={styles.card}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <FaUsers style={styles.icon} />
              <h3 style={styles.cardTitle}>Collaborative Team</h3>
              <p style={styles.cardText}>
                Thrive in a culture of openness, diversity, and innovation.
              </p>
            </div>
            <div
              style={styles.card}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <FaChartLine style={styles.icon} />
              <h3 style={styles.cardTitle}>Career Growth</h3>
              <p style={styles.cardText}>
                Upskill and grow with mentorship and exciting challenges.
              </p>
            </div>
            <div
              style={styles.card}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <FaHeart style={styles.icon} />
              <h3 style={styles.cardTitle}>Impactful Work</h3>
              <p style={styles.cardText}>
                Contribute to building fair and bias-free hiring for all.
              </p>
            </div>
          </div>
        </div>

        {/* Open Positions */}
        <div style={{ ...styles.section, ...styles.jobsSection }}>
          <h2 style={{ ...styles.heroHeading, fontSize: "32px" }}>
            Open Positions
          </h2>
          {jobs.map((job, index) => (
            <div key={index} style={styles.jobCard}>
              <h3 style={styles.jobTitle}>{job.title}</h3>
              <p style={styles.jobDetails}>
                Location: {job.location} | Experience: {job.experience}
              </p>
              <p style={styles.jobDesc}>{job.description}</p>
              <button style={styles.applyBtn} onClick={()=>navigate("/contact-us")}>
                Apply Now
              </button>
            </div>
          ))}
        </div>

        {/* Life at eBench.ai */}
        <div style={{ ...styles.section, ...styles.cultureSection }}>
          <h2 style={{ ...styles.heroHeading, fontSize: "32px" }}>
            Life at eBench.ai
          </h2>
          <p style={styles.heroText}>
            At eBench.ai, we believe work should be exciting, fulfilling, and
            impactful. Our culture is built on innovation, diversity, and
            collaboration. We celebrate curiosity, encourage ownership, and
            support each other in building solutions that matter.
          </p>
          <div style={styles.cultureGrid}>
            <div style={styles.cultureCard}>
              <img
                src={careerHero}
                alt="Team Collaboration"
                style={styles.cultureImage}
              />
              <h3 style={styles.cultureTitle}>
                <FaSmile /> Fun & Inclusive
              </h3>
              <p style={styles.cultureText}>
                From team activities to open discussions, we value a fun,
                inclusive environment where everyone belongs.
              </p>
            </div>
            <div style={styles.cultureCard}>
              <img
                src={life2}
                alt="Innovation"
                style={styles.cultureImage}
              />
              <h3 style={styles.cultureTitle}>
                <FaLightbulb /> Innovation-Driven
              </h3>
              <p style={styles.cultureText}>
                We encourage experimentation, creativity, and pushing boundaries
                to build smarter solutions.
              </p>
            </div>
            <div style={styles.cultureCard}>
              <img
                src={careerHero}
                alt="Global Team"
                style={styles.cultureImage}
              />
              <h3 style={styles.cultureTitle}>
                <FaGlobe /> Global Mindset
              </h3>
              <p style={styles.cultureText}>
                With a distributed team, we embrace diversity and bring global
                perspectives into everything we do.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Career;
